import React from 'react'
import Login from './LOGIN/login'

function initialPage() {
  return (
    <div>
        <Login />
    </div>
  )
}

export default initialPage